<ejs-dialog #dialog [buttons]='dlgButtons' isModal='true' [animationSettings]='animationSettings'
            [closeOnEscape]='false' [showCloseIcon]='false' [width]='width' [customers]='customers' tabindex="0">

    <div class="card">
        <div class="card-header bg-primary">
            <h4 class="card-title text-white" aria-label="Select a company"> Select a Company</h4>
        </div>
        <div class="card-body">
            <div class="message" aria-label="Before you start, let's pick a company to work with">Before you start, let's pick a company to work with.</div>
            <ejs-dropdownlist #csCustomersddw id='csCustomersddw' [dataSource]='customers' [fields]='fields'
                   (change)='customerChanged($event)' [placeholder]='customersWaterMark' [popupHeight]='ddwHeight'>
            </ejs-dropdownlist>
        </div>
    </div>
</ejs-dialog>
